export const standsOutUpscale = [
	{
		icon: '✅',
		title: 'standsOutData_title1',
		subtitle: 'standsOutData_subtitle1',
	},
	{
		icon: '✅',
		title: 'standsOutData_title2',
		subtitle: 'standsOutData_subtitle2',
	},
	{
		icon: '✅',
		title: 'standsOutData_title3',
		subtitle: 'standsOutData_subtitle3',
	},
	{
		icon: '✅',
		title: 'standsOutData_title4',
		subtitle: 'standsOutData_subtitle4',
	},
];
